import React from 'react';
import './styles/global.scss';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import './App.css';
import Navigator from './components/layout/Navigator';

import ClientSubmissionForm from './pages/ClientSubmissionForm'
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
    <div className="App">
      <Header />
      <main>
        <Navigator />
      </main>
      <Footer />
    </div>
    </Router>
  );
}

export default App;
